import { render, staticRenderFns } from "./BOMItems.vue?vue&type=template&id=4d82b206&"
import script from "./BOMItems.vue?vue&type=script&lang=js&"
export * from "./BOMItems.vue?vue&type=script&lang=js&"
import style0 from "./BOMItems.vue?vue&type=style&index=0&id=4d82b206&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports